import axios from "axios";

export default {
  getNotifications(context) {
    // axios.get('notification/internal').then((res) => {
    axios({
      method: "GET",
      params: { internal: 1 },
      url: `notification`,
    })
      .then((res) => {
        context.commit("setNotifications", res.data.data);

        context.commit("setUnread", res.data.unread_notifications_count);
      })
      .catch(() => {});
  },
};
